import dataRootRoute from './data-root-route'

export default () => [
  dataRootRoute(),
]
